import React from 'react';

import { defaultTextStyle } from 'settings/theme';
import UnicodeUtil from 'utils/UnicodeUtil';

export default function ErrorMessage(props) {
    const {
        text,
        containerStyle,
        style,
        ...restProps,
    } = props;
    
    return (
        <div style={containerStyle}>
            <span
                className="error"
                style={{
                    ...defaultTextStyle,
                    fontSize: '1em',
                    ...style,
                }}
                {...restProps}
            >
                {text ? text : UnicodeUtil.zeroWidthSpace}
            </span>
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/components/vistaprintUILibrary/ErrorMessage.js